/**
 * The default  application constants should be defined here
 * @type {string}
 */
export const SystemError: string =
  "We're sorry, a system error has occured. Please try again later";
export const NetworkError: string =
  "We're sorry, your connection was dropped. Please check your internet connection";
